import { useAsiAccessDecision } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIntl } from 'react-intl';
export function useViewerComputerRestriction({ enabled = true } = {}) {
    const { data: decision } = useAsiAccessDecision({ enabled });
    const { isViewer } = useIsSubscribed();
    const { $t } = useIntl();
    // Refuse known Viewers before task setup even while the billing query is unresolved.
    return isViewer || decision?.denial_reason === 'viewer'
        ? $t({
            defaultMessage: 'Your Viewer plan does not include Computer',
            id: 'c3a8215454',
            description: 'Explains why a Viewer cannot submit Computer requests or select Computer mode',
        })
        : undefined;
}
//# sourceMappingURL=useViewerComputerRestriction.js.map